export enum DocumentModalOptions {
  None = 'None',
  RequestDocuments = 'RequestDocuments',
  RequestDocumentsOnlyIfNoAssociatedDocuments = 'RequestDocumentsOnlyIfNoAssociatedDocuments',
  UploadDocuments = 'UploadDocuments',
  UploadDocumentsOnlyIfNoAssociatedDocuments = 'UploadDocumentsOnlyIfNoAssociatedDocuments',
}
